import React, { Component } from 'react';
import { Column, Table, AutoSizer, InfiniteLoader } from 'react-virtualized';
import Alert from './Alert';
var Api = require('./Config');
import BooleanAlert from './BooleanAlert';
import _ from 'lodash';
import TableLoader from './TableLoader';
const VIEW_ALL = 'View all';

export default class ArchivedPatients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      journeys: [],
      refFilter: '',
      tCodeFilter: '',
      statusFilter: VIEW_ALL,
      startIdx: 0,
      queryAmount: 50,
      maxRows: 0,
      isLoading: false,
    };
    this.openJourney = this.openJourney.bind(this);
    this.getTableCell = this.getTableCell.bind(this);

    // adding timeout so we only do a search and call api when user stops typing
    // in the patient and tcode search
    this.timeout = 0;
  }

  openJourney(t_code) {
    this.props.history.push('/JourneyDetail/' + t_code);
  }

  async getPatients(startIdx, resetList = true) {
    this.setState({ isLoading: true });

    if (resetList) {
      this.setState({ journeys: [] });
    }

    const filters = {
      tcode: this.state.tCodeFilter.toLowerCase().replaceAll(' ', ''),
      patientRef: this.state.refFilter.toLowerCase(),
    };

    if (this.state.statusFilter != VIEW_ALL) {
      filters.status = this.state.statusFilter;
    }

    const newIdx = resetList ? startIdx : startIdx + this.state.queryAmount;
    const journeys = await Api.getJourneysForDoctor(true, newIdx, this.state.queryAmount, filters);

    let tcodes;
    if (resetList) {
      tcodes = journeys.tcodes;
    } else {
      tcodes = this.state.journeys.concat(journeys.tcodes);
    }

    this.setState({
      journeys: tcodes,
      startIdx: parseInt(journeys.newIndex),
      maxRows: parseInt(journeys.maxRows),
      isLoading: false,
    });
  }

  componentDidMount() {
    this.getPatients(0);
  }

  getTableCell({ cellData, dataKey, rowData }) {
    let cellItem;

    switch (dataKey) {
      case 't_code':
        cellItem = Api.formatTCode(cellData);
        break;
      case 'journey_start_date':
        cellItem = Api.getDateFormat(cellData);
        break;
      case 'deleted_date':
        cellItem = Api.getDateFormat(cellData);
        break;
      case 'view':
        cellItem = (
          <button onClick={() => this.openJourney(rowData.t_code)} className="btn btn-md btn-primary">
            View Journey
          </button>
        );
        break;
      case 'archived':
        cellItem = rowData.reason_text;
        break;
    }

    return cellItem;
  }

  getColumnStyle() {
    return { whiteSpace: 'normal' };
  }

  headerRenderer({ label }) {
    return <span style={{ textTransform: 'none' }}>{label}</span>;
  }

  render() {
    return (
      <div>
        <div>
          <h3>Archived Patient T-Codes</h3>
          <div style={{ height: 20 }}></div>
          <div className="well col-md-12">
            <div className="col-md-1">Search:</div>
            <div className="col-md-3">
              <label style={{ width: '100%' }}>
                Patient #
                <input
                  onChange={(e) => {
                    const searchText = e.target.value;
                    if (this.timeout) clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                      this.setState({ refFilter: searchText });
                      this.getPatients(0);
                    }, 300);
                  }}
                  className="form-control col-md-12"
                  type="text"
                  placeholder="Patient #"
                />
              </label>
            </div>
            <div className="col-md-2">
              <label style={{ width: '100%' }}>
                T-Code:
                <input
                  onChange={(e) => {
                    const searchText = e.target.value;
                    if (this.timeout) clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                      this.setState({ tCodeFilter: searchText });
                      this.getPatients(0);
                    }, 300);
                  }}
                  className="form-control"
                  type="text"
                  placeholder="T-Code"
                />
              </label>
            </div>
            <div className="col-md-3">
              <label>
                Status
                <select
                  disabled={this.state.isLoading}
                  onChange={(e) => {
                    this.setState({ statusFilter: e.target.value });
                    this.getPatients(0);
                  }}
                  style={{ minWidth: 200 }}
                  className="form-control select"
                >
                  <option>{VIEW_ALL}</option>
                  <option>In-Progress</option>
                  <option>Missed</option>
                  <option>Completed</option>
                  <option>Created</option>
                </select>
              </label>
            </div>
          </div>
          <div
            className="table-responsive"
            style={{ width: '100%', height: 800, display: 'flex', marginBottom: 100, overflow: 'hidden' }}
          >
            <AutoSizer>
              {({ width }) => {
                return (
                  <InfiniteLoader
                    isRowLoaded={({ index }) => {
                      return !!this.state.journeys[index];
                    }}
                    loadMoreRows={() => {
                      if (this.state.isLoading) return;
                      this.getPatients(this.state.startIdx, false);
                    }}
                    rowCount={this.state.maxRows}
                  >
                    {({ onRowsRendered, registerChild }) => (
                      <Table
                        ref={registerChild}
                        onRowsRendered={onRowsRendered}
                        width={width}
                        height={800}
                        headerHeight={60}
                        rowStyle={{
                          borderBottom: '1px solid #ddd',
                          paddingTop: 10,
                          paddingBottom: 10,
                        }}
                        rowHeight={60}
                        rowCount={this.state.journeys.length}
                        rowGetter={({ index }) => this.state.journeys[index]}
                        noRowsRenderer={() => (this.state.isLoading ? <TableLoader /> : null)}
                      >
                        <Column
                          label="Patient #"
                          dataKey="patient_ref"
                          width={width / 8}
                          headerRenderer={this.headerRenderer}
                          style={this.getColumnStyle()}
                        />
                        <Column
                          label="Year of birth"
                          dataKey="yob"
                          width={width / 15}
                          headerRenderer={this.headerRenderer}
                          style={this.getColumnStyle()}
                        />
                        <Column
                          label="Gender"
                          dataKey="gender"
                          width={width / 13}
                          headerRenderer={this.headerRenderer}
                          style={this.getColumnStyle()}
                        />
                        <Column
                          label="Journey"
                          dataKey="journey_name"
                          width={width / 5}
                          headerRenderer={this.headerRenderer}
                          style={this.getColumnStyle()}
                        />
                        <Column
                          label="T-Code #"
                          dataKey="t_code"
                          cellRenderer={this.getTableCell}
                          width={width / 11}
                          headerRenderer={this.headerRenderer}
                          headerStyle={{ ...this.getColumnStyle(), textAlign: 'center' }}
                          style={{ ...this.getColumnStyle(), textAlign: 'center' }}
                        />
                        <Column
                          label="Created Date"
                          dataKey="journey_start_date"
                          cellRenderer={this.getTableCell}
                          width={width / 12}
                          headerRenderer={this.headerRenderer}
                          style={this.getColumnStyle()}
                        />
                        <Column
                          label="Archived Date"
                          dataKey="deleted_date"
                          cellRenderer={this.getTableCell}
                          width={width / 12}
                          headerRenderer={this.headerRenderer}
                          style={this.getColumnStyle()}
                        />
                        <Column
                          label="Reason"
                          dataKey="archived"
                          cellRenderer={this.getTableCell}
                          width={width / 7}
                          headerRenderer={this.headerRenderer}
                          style={this.getColumnStyle()}
                        />
                        <Column
                          label=""
                          dataKey="view"
                          cellRenderer={this.getTableCell}
                          width={width / 10}
                          style={this.getColumnStyle()}
                        />
                      </Table>
                    )}
                  </InfiniteLoader>
                );
              }}
            </AutoSizer>
          </div>
        </div>

        <BooleanAlert
          ref={(ref) => {
            this.booleanAlert = ref;
          }}
        />

        <Alert
          ref={(a) => {
            this.alert = a;
          }}
        />
      </div>
    );
  }
}
